class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    const STORAGE_KEY = 'hbk-ann-dismissed';
    const spacer = document.querySelector('.hbk-ann__spacer');

    if (sessionStorage.getItem(STORAGE_KEY)) {
      this.hidden = true;
      if (spacer) spacer.hidden = true;
      return;
    }

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reducedMotion) {
      this.dataset.animation = 'fade';
    }

    this.messages  = Array.from(this.querySelectorAll('.hbk-ann__message'));
    this.prevBtn   = this.querySelector('.hbk-ann__arrow--prev');
    this.nextBtn   = this.querySelector('.hbk-ann__arrow--next');
    this.closeBtn  = this.querySelector('.hbk-ann__close');
    this.current   = 0;
    this.total     = this.messages.length;
    this.timer     = null;
    this.spacer    = spacer;

    const autoRotate = this.dataset.autoRotate === 'true' && !this.reducedMotion;
    const interval   = parseInt(this.dataset.interval, 10) * 1000;

    this._syncHeight();
    window.addEventListener('resize', () => this._syncHeight());

    if (autoRotate && this.total > 1) {
      this._startTimer(interval);
      this.addEventListener('mouseenter', () => this._clearTimer());
      this.addEventListener('mouseleave', () => this._startTimer(interval));
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this._clearTimer();
        this._goTo(this.current - 1);
        if (autoRotate) this._startTimer(interval);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this._clearTimer();
        this._goTo(this.current + 1);
        if (autoRotate) this._startTimer(interval);
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        sessionStorage.setItem(STORAGE_KEY, '1');
        this._dismiss();
      });
    }
  }

  _startTimer(interval) {
    this.timer = setInterval(() => this._goTo(this.current + 1), interval);
  }

  _clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  _goTo(index) {
    if (this.total <= 1) return;

    const prev = this.messages[this.current];
    this.current = ((index % this.total) + this.total) % this.total;
    const next = this.messages[this.current];

    if (this.dataset.animation === 'fade' || this.reducedMotion) {
      prev.classList.remove('is-active');
      next.classList.add('is-active');
    } else {
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.addEventListener('transitionend', () => prev.classList.remove('is-leaving'), { once: true });
      requestAnimationFrame(() => next.classList.add('is-active'));
    }

    this.dispatchEvent(new CustomEvent('announcement:change', {
      bubbles: true,
      detail: { index: this.current, total: this.total }
    }));
  }

  _dismiss() {
    this.hidden = true;
    if (this.spacer) this.spacer.hidden = true;
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
  }

  _syncHeight() {
    const h = this.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', h + 'px');
    if (this.spacer) this.spacer.style.height = h + 'px';
  }
}

customElements.define('announcement-bar', AnnouncementBar);
